/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class AlignAPI
 * @hideconstructor
 * @classdesc API class that is used to apply the align action.
 */
define([], () => {
	class AlignAPI {

		/**
		 * @function AlignAPI#applyAction
		 * @description Apply alignment action.
		 * @param {Object[]} selection The selected icon object from align property dialog
		 * 
		 * @example
		 * [{
		 *  layoutIds: ['model0000016a0890313c_00000000', 'model0000016a089069b7_00000000']
		 * 	name: 'right',
		 * 	value: 'align-object-right_16'
		 * }]
		 */
		applyAction() {}
	}

	return AlignAPI;
});